import React from 'react';

import { FormattedMessage } from '../../util/reactIntl';
import { isFieldForListingType } from '../../util/fieldHelpers';

import { Heading } from '../../components';

import css from './ListingPage.module.css';
import Calendar from './calendar.svg';
import Star from './star.svg';

const SectionDetailsMaybe = props => {
  const { publicData, metadata = {}, listingFieldConfigs, isFieldForCategory, intl, variant = 'default' } = props;

  if (!publicData || !listingFieldConfigs) {
    return null;
  }

  const pickListingFields = (filteredConfigs, config) => {
    const { key, schemaType, enumOptions, showConfig = {} } = config;
    const listingType = publicData.listingType;
    const isTargetListingType = isFieldForListingType(listingType, config);
    const isTargetCategory = isFieldForCategory(config);

    const { isDetail, label } = showConfig;
    const publicDataValue = publicData[key];
    const metadataValue = metadata[key];
    const value = typeof publicDataValue != null ? publicDataValue : metadataValue;

    if (isDetail && isTargetListingType && isTargetCategory && typeof value !== 'undefined') {
      const findSelectedOption = enumValue => enumOptions?.find(o => enumValue === `${o.option}`);
      const getBooleanMessage = value =>
        value
          ? intl.formatMessage({ id: 'SearchPage.detailYes' })
          : intl.formatMessage({ id: 'SearchPage.detailNo' });
      const optionConfig = findSelectedOption(value);

      return schemaType === 'enum'
        ? filteredConfigs.concat({ key, value: optionConfig?.label, label })
        : schemaType === 'boolean'
          ? filteredConfigs.concat({ key, value: getBooleanMessage(value), label })
          : schemaType === 'long'
            ? filteredConfigs.concat({ key, value, label })
            : filteredConfigs;
    }
    return filteredConfigs;
  };

  const existingListingFields = listingFieldConfigs.reduce(pickListingFields, []);

  return existingListingFields.length > 0 ?
    <section className={css.sectionDetails}>
      {variant === 'default' ?
        <>
          <Heading as="h2" rootClassName={css.sectionHeading}>
            <FormattedMessage id="ListingPage.detailsTitle" />
          </Heading>
          <ul className={css.details}>
            {existingListingFields.map(detail => (
              <li key={detail.key} className={css.detailsRow}>
                <span className={css.detailLabel}>{detail.label}</span>
                <span>{detail.value}</span>
              </li>
            ))}
          </ul>
        </>
        :
        <div className={css.detailsWrapper}>
          {existingListingFields.map((detail, index) => {
            const icon = detail.key === 'yearcard' ? Calendar : detail.key === 'gradeofcard' ? Star : null;
            const isFirst = index === 0;

            return (
              <div
                key={detail.key}
                className={`${css.detailItem} ${!isFirst ? css.detailWithBorder : ''}`}
              >
                {icon && <img src={icon} alt="" className={css.detailIcon} />}
                <div className={css.detailTextBlock}>
                  <div className={css.label}>{detail.label}</div>
                  <div className={css.value}>{detail.value}</div>
                </div>
              </div>
            );
          })}
        </div>
      }
    </section>
    : null;
};

export default SectionDetailsMaybe;
